import { Mql } from '@adalong/schemas';
import type { FilterBuilt } from '@src/fragments/Filters/utils/MediaFilterBuilder';

/**
 * Convert the Discover query parts into the MQL stored by an auto collection.
 *
 * Discover's partial search is represented by `search`, whose fields are
 * alternatives. Keep those alternatives in one `or` clause while preserving
 * all regular filters as `and` clauses.
 */
export function mergeFilterAndSearchToMQL(filterBuilt: FilterBuilt): Mql {
  const and = [...(filterBuilt.filter?.and ?? [])];

  if (filterBuilt.search?.length) {
    and.push({
      or: filterBuilt.search.map((searchItem) => ({ ...searchItem })),
    });
  }

  return {
    ...filterBuilt.filter,
    and,
  };
}
